import Api from './api';

/**
 * The GloryBoard adjustment, sent to the endpoint that actually moves a balance.
 *
 * `{ silent: true }` so a refusal comes back as data rather than a global toast: the message
 * belongs inside the confirmation the administrator is looking at, and each refusal has its own
 * wording. Callers branch on `code` — INSUFFICIENT_POINTS, INSUFFICIENT_PERMISSIONS, RATE_LIMITED,
 * ADJUSTMENT_INCOMPLETE — and treat anything else as a system failure they may retry.
 *
 * `adjustmentId` is fixed by the caller when the administrator confirms and reused unchanged on
 * every retry of that confirmation. It is what makes a retry a retry rather than a second
 * subtraction, and sending a fresh one on retry would defeat the whole guarantee.
 */
export const applyPointAdjustment = async ({
  teamId,
  userId,
  adjustmentId,
  actionType,
  points,
  reasonCode
}) =>
  Api.post(
    '/admin/teams/pointAdjustment',
    { teamId, userId, adjustmentId, actionType, points, reasonCode },
    null,
    { silent: true }
  );

/** The adjustments already applied to one participant on one team, newest first. */
export const fetchPointAdjustments = async ({ teamId, userId }) =>
  Api.get(`/admin/teams/pointAdjustments?teamId=${teamId}&userId=${userId}&limit=50`, null, {
    silent: true
  });

export default { applyPointAdjustment, fetchPointAdjustments };
